export const FETCH_MISC_PRODUCT_PENDING = "FETCH_MISC_PRODUCT_PENDING";
export const FETCH_MISC_PRODUCT_REJECTED = "FETCH_MISC_PRODUCT_REJECTED";
export const FETCH_MISC_PRODUCT_FULFILLED = "FETCH_MISC_PRODUCT_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/miscProduct.js